import { useEffect, useRef, useState } from "react"

// Shared "Sync now" polling for the dashboard data pages (transactions,
// customers, subscriptions). The sync is async (worker + Shopify round-trip), so
// after triggering we poll the index JSON every few seconds — bumping reloadKey
// to refetch — until the partner-level run reports done (meta.state idle + a
// newer last_synced_at) or the attempt budget is exhausted (doc 10).
//
//   const [reloadKey, setReloadKey] = useState(0)
//   const { syncing, startSync } = useSyncPoll(data, setReloadKey)
// Pass `syncing` + `startSync` to <SyncNowButton>, and reloadKey to the fetch effect.
export function useSyncPoll(data, setReloadKey, { intervalMs = 2500, maxAttempts = 15 } = {}) {
  const [syncing, setSyncing] = useState(false)
  const baseline = useRef(null)

  const startSync = () => {
    baseline.current = data?.meta?.last_synced_at || null
    setSyncing(true)
  }

  useEffect(() => {
    if (!syncing) return undefined
    let attempts = 0
    const id = setInterval(() => {
      attempts += 1
      setReloadKey((k) => k + 1)
      if (attempts >= maxAttempts) setSyncing(false)
    }, intervalMs)
    return () => clearInterval(id)
  }, [syncing, setReloadKey, intervalMs, maxAttempts])

  useEffect(() => {
    if (!syncing || !data?.meta) return
    const { state, last_synced_at: lastSyncedAt } = data.meta
    if (state !== "running" && lastSyncedAt && lastSyncedAt !== baseline.current) {
      setSyncing(false)
    }
  }, [data, syncing])

  return { syncing, startSync }
}
